import Colors from "../../../../theme/colors";

const style = {
  container: {
    color: Colors.white,
  },
  tableHeadCell: {
    fontSize: "13px",
    border: "none",
    padding: "10px 8px 10px 20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "#EDEDED",
    whiteSpace: "nowrap",
    color: "#5E5E5E",
    fontWeight: "600",
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    border: "none",
    color: Colors.white,
  },
  emptyList: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
  },
};
export default style;
